import React, { useContext, useEffect, useRef } from "react";
import { fabric } from "fabric";
import { useDispatch } from "react-redux";
import { CanvasContext } from "./GenerationContext";
import { renderSlideForGeneration } from "../../canvasUtils";
import { useSelector } from "react-redux";
import { setVideoGenerateWarningMessage } from "../../store/common/uiSlice";
import { useLocation } from "react-router-dom";

let creating = false;
const GenerationCanvas = () => {
  const canvasRef = useRef(null);

  const { slides } = useSelector((state) => state.slides);
  const project = useSelector((state) => state.project);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const w = queryParams.get("width") || 1920;

  // Get the value of the 'height' parameter
  const h = queryParams.get("height") || 1080;
  console.log("generationVideo", w, h);
  const dimensions = { width: +w, height: +h };
  const dispatch = useDispatch();
  let setCanvas, contextCanvas;
  let canvasCont = useContext(CanvasContext);
  setCanvas = canvasCont.setCanvas;
  contextCanvas = canvasCont.canvas;
  console.log("no voices", project.isNonVoice);
  // Effect for initializing and setting up the Fabric canvas
  useEffect(() => {
    console.log("hello generation canvas is working fine ");
    // console.log(creating, contextCanvas);
    if (project?.isNonVoice) {
      if (contextCanvas === null && creating === false) {
        creating = true;
        const canvasElement = canvasRef.current;
        const canvas = new fabric.Canvas(canvasElement, {
          height: dimensions.height,
          width: dimensions.width,
        });

        setCanvas(canvas);
        canvas.clear();
        renderSlideForGeneration(canvas, slides, project, dispatch);
        creating = false;
        return () => {
          canvas.dispose();
          setCanvas(null);
        };
      }
    }
    let missingAvatarOnSlide = [];
    let missingScriptOnSlide = [];
    slides.forEach((element, index) => {
      if (project?.isFaceless) {
        if (!element.voiceFile) {
          missingScriptOnSlide.push(index + 1);
        }
      } else if (!element.objects.length) {
        missingAvatarOnSlide.push(index + 1);
        missingScriptOnSlide.push(index + 1);
      } else {
        const findAvatar =
          element.objects.find(
            (ele) => (ele.type || "").toLowerCase() === "avatar"
          ) || !!project?.isFaceless;
        if (!findAvatar) {
          missingAvatarOnSlide.push(index + 1);
        }
        if (!!findAvatar && !element.voiceFile) {
          missingScriptOnSlide.push(index + 1);
        }
      }
    });
    if (missingAvatarOnSlide.length || missingScriptOnSlide.length) {
      const message =
        (missingAvatarOnSlide.length
          ? `Avatar is missing for video generation. Please add avatar on slide ${missingAvatarOnSlide.join(
              ", "
            )}`
          : "") +
        (missingAvatarOnSlide.length && missingScriptOnSlide.length
          ? "&"
          : "") +
        (missingScriptOnSlide.length
          ? "The transcript is missing for video generation. Please add transcript from script tab on slide " +
            missingScriptOnSlide.join(", ")
          : "");

      dispatch(setVideoGenerateWarningMessage(message));
    } else {
      if (contextCanvas === null && creating === false) {
        creating = true;
        const canvasElement = canvasRef.current;
        const canvas = new fabric.Canvas(canvasElement, {
          height: dimensions.height,
          width: dimensions.width,
        });

        setCanvas(canvas);
        canvas.clear();
        renderSlideForGeneration(canvas, slides, project, dispatch);
        creating = false;
        return () => {
          canvas.dispose();
          setCanvas(null);
        };
      }
    }
    // Cleanup function
  }, [dispatch]);

  return (
    <div
      style={{
        transform: "scale(0.6",
        position: "absolute",
        top: -100,
        left: -250,
        zIndex: 30,
        visibility: "hidden",
      }}
    >
      <canvas
        ref={canvasRef}
        width={dimensions.width}
        height={dimensions.height}
        previewMode
      />
    </div>
  );
};

export default GenerationCanvas;
